export interface RouteRequest {
  origin: LocationSpec;
  destination: LocationSpec;
  profile?: string;
  weight_overrides?: WeightOverrides;
}

export type LocationSpec = CoordsSpec | NodeIdSpec;

export interface CoordsSpec {
  lat: number;
  lon: number;
}

export interface NodeIdSpec {
  node_id: number;
}

export interface WeightOverrides {
  distance?: number;
  stress?: number;
  climb?: number;
  surface?: number;
}

export interface RouteResponse {
  routes: ComputedRoute[];
}

export interface ComputedRoute {
  label: string;
  geometry: [number, number][];
  stats: RouteStats;
  details: RouteDetails;
  cost_breakdown: CostBreakdown;
  elevation_profile: ElevationPoint[];
  // Per-segment attributes aligned with geometry (one entry per edge in path order).
  // The map uses these to color the highlighted route green->red by hill or safety.
  segment_grades: number[];
  segment_stress: number[];
  // Geometry of edges the router relaxed (considered) during search, for the
  // "all routes it thought of" exploration layer. Each entry is a 2-point line segment.
  explored_geometry?: [[number, number], [number, number]][];
  // Weight tuple this route was computed with (present for precompute bundle entries).
  weights?: RoutingWeights;
}

export interface RoutingWeights {
  distance: number;
  stress: number;
  climb: number;
  surface: number;
}

export interface ElevationPoint {
  dist_m: number;
  elevation_m: number;
}

export interface RouteStats {
  distance_m: number;
  duration_s: number;
  elevation_gain_m: number;
  elevation_loss_m: number;
  max_grade_pct: number;
  avg_grade_pct: number;
  safety_score: number;
}

export interface RouteDetails {
  climb_m: number;
  bike_infra_pct: number;
  contraflow_m: number;
  rough_surface_m: number;
  busy_roads_m: number;
}

export interface CostBreakdown {
  distance_cost: number;
  stress_cost: number;
  climb_cost: number;
  surface_cost: number;
  total_cost: number;
}

export interface ProfileInfo {
  name: string;
  description: string;
}

export const ROUTE_COLORS: Record<string, string> = {
  normal: '#e94560',
  calm: '#45b7d1',
  safest: '#4ecdc4',
  flat: '#ff6b6b',
};

export interface GeocodeResult {
  display_name: string;
  lat: number;
  lon: number;
}

// Precompute bundle request/response types.
export interface PrecomputeRequest {
  origin: LocationSpec;
  destination: LocationSpec;
}

export interface PrecomputeResponse {
  origin_id: number;
  destination_id: number;
  routes: ComputedRoute[];
}
